// File: /Users/ivanfier/gitlab/Darkroom-Git/ael-website/integrations/mandrill/index.ts
export { combinedContactAction, mandrillContactAction } from './action'

export type { ContactData, MandrillConfig } from './action'
